<template>
	<div class="flex flex-col items-start gap-0.5">
		<div v-if="props.label" class="pl-1 text-sm">
			{{ props.label }}
		</div>
		<ion-input
			v-bind="$attrs"
			:label="undefined"
			:helper-text="undefined"
		/>
		<div v-if="props.error" class="pl-1 text-xs text-red-600">
			{{ props.error }}
		</div>
		<div
			v-if="props.helperText"
			class="pl-1 text-xs text-[var(--ion-color-medium)]"
		>
			{{ props.helperText }}
		</div>
	</div>
</template>

<script setup lang="ts">
	import { IonInput } from "@ionic/vue";

	interface SgInputProps {
		label?: string;
		error?: string;
		helperText?: string;
	}
	const props = defineProps<SgInputProps>();

	defineOptions({
		inheritAttrs: true,
	});
</script>

<style scoped>
	ion-input {
		--background: #eee;
		--padding-start: 0.5rem;
		--padding-end: 0.5rem;
		--border-radius: 0.5rem;
	}
</style>
